"use strict";

class ImageScroll {
  constructor() {
    this.laptop = document.querySelector( '#laptop' );
    this.analytics = document.querySelector( '#analytics' );
    this.careers = document.querySelector( '#careers' );
    this.aboutUs = document.querySelector( '#about-us' );
    this.services = document.querySelector( '#services' );
    this.specialExpertise = document.querySelector( '#special-expertise' );
    this.missionCritical = document.querySelector( '#mission-critical' );
    this.contact = document.querySelector( '#contact-us' );
    this.raf;
    this.events();
  }

  events() {
    window.addEventListener( 'scroll', this.rafScroll.bind(this) , false);
  }

  // methods
  rafScroll() {
    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
    }
    if( window.innerWidth >= 640 ) { 
      this.raf = window.requestAnimationFrame(this.shiftImage.bind(this));
    } else {
      window.requestAnimationFrame(this.resetImage.bind(this));
    }
  }

  resetImage() {
    if( this.laptop ) {
      this.laptop.style.backgroundPositionY = `0px`;
    }
    
    if( this.analytics ) {
      this.analytics.style.backgroundPositionY = `0px`;
    }
  
    if( this.careers ) {
      this.careers.style.backgroundPositionY = `0px`;
    }
  
    if( this.aboutUs ) {
      this.aboutUs.style.backgroundPositionY = `0px`;
    }
  
    if( this.services ) {
      this.services.style.backgroundPositionY = `0px`;
    }
  
    if( this.specialExpertise ) {
      this.specialExpertise.style.backgroundPositionY = `0px`;
    }

    if( this.missionCritical ) {
      this.missionCritical.style.backgroundPositionY = `0px`;
    }

    if( this.contact ) {
      this.contact.style.backgroundPositionY = `0px`;
    }
  }

  shiftImage( e ) {
    if( this.laptop ) {
      this.laptop.style.backgroundPositionY = `${ -window.pageYOffset / 10 }px`;
    }
    
    if( this.analytics ) {
      this.analytics.style.backgroundPositionY = `${ -window.pageYOffset / 14 }px`;
    }
  
    if( this.careers && this.aboutUs ) {
      let top = this.careers.getBoundingClientRect().top;
      this.careers.style.backgroundPositionY = `${ top / 7 - 90 }px`;
    } else if( this.careers ) {
      let top = this.careers.getBoundingClientRect().top;
      this.careers.style.backgroundPositionY = `${ top / 9 - 90 }px`;
    }
  
    if( this.aboutUs ) {
      this.aboutUs.style.backgroundPositionY = `${ window.pageYOffset / 2 }px`;
    }
  
    if( this.services ) {
      this.services.style.backgroundPositionY = `${ window.pageYOffset / 2 }px`;
    }
  
    if( this.specialExpertise ) {
      this.specialExpertise.style.backgroundPositionY = `${ window.pageYOffset / 2 }px`;
    }

    if( this.missionCritical ) {
      this.missionCritical.style.backgroundPositionY = `${ window.pageYOffset / 2 }px`;
    }

    if( this.contact ) {
      this.contact.style.backgroundPositionY = `${ window.pageYOffset / 2 }px`;
    }
  };
}

export default ImageScroll;